var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNervousness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 4.96847C15.206 3.18526 13.4682 1.57954 11.5688 0.180969C11.4006 0.0631832 11.2003 0 10.995 0C10.7897 0 10.5894 0.0631832 10.4213 0.180969C8.52531 1.58012 6.7909 3.18583 5.25 4.96847C1.81375 8.91472 0 13.0747 0 16.9997C0 19.9171 1.15893 22.715 3.22183 24.7779C5.28473 26.8408 8.08262 27.9997 11 27.9997C13.9174 27.9997 16.7153 26.8408 18.7782 24.7779C20.8411 22.715 22 19.9171 22 16.9997C22 13.0747 20.1863 8.91472 16.75 4.96847ZM17.9813 18.1672C17.7219 19.6156 17.0251 20.9498 15.9846 21.9901C14.944 23.0304 13.6097 23.727 12.1612 23.986C12.1079 23.9945 12.054 23.9991 12 23.9997C11.7492 23.9997 11.5075 23.9053 11.323 23.7354C11.1384 23.5655 11.0245 23.3325 11.0037 23.0825C10.9829 22.8325 11.0569 22.5839 11.2108 22.3859C11.3648 22.1878 11.5876 22.0549 11.835 22.0135C13.9062 21.6647 15.6637 19.9072 16.015 17.8322C16.0594 17.5707 16.2059 17.3374 16.4223 17.1839C16.6387 17.0303 16.9072 16.969 17.1688 17.0135C17.4303 17.0579 17.6635 17.2044 17.8171 17.4208C17.9706 17.6371 18.0319 17.9056 17.9875 18.1672H17.9813Z",
    fill: "url(#paint0_linear_668_12198)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_12198",
    x1: 0,
    y1: 27.9997,
    x2: 28.6565,
    y2: 16.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNervousness);
export default __webpack_public_path__ + "static/media/Nervousness.221c646da636efd1d1b662ecedf8234b.svg";
export { ForwardRef as ReactComponent };